var map = {
	"./account.png": "JO2b",
	"./account_fill.png": "C6nL",
	"./all_workbench.png": "2odg",
	"./all_workbench_fill.png": "m2mS",
	"./amazon.png": "Wae/",
	"./amazon_fill.png": "Fynm",
	"./analytics.png": "uwLV",
	"./analytics_fill.png": "15dV",
	"./bi.png": "hg6p",
	"./bi_fill.png": "Kvej",
	"./bill.png": "f0EJ",
	"./bill_fill.png": "Qz+3",
	"./charge.png": "//JE",
	"./charge_fill.png": "GC1w",
	"./cloud.png": "Yk/n",
	"./cloud_fill.png": "FgiY",
	"./company.png": "M6Fk",
	"./company_fill.png": "1ZL8",
	"./customer.png": "vQJo",
	"./customer_fill.png": "BDPe",
	"./data_analysis.png": "UQMB",
	"./data_analysis_fill.png": "XhC4",
	"./finance.png": "7YJH",
	"./finance_fill.png": "IgQE",
	"./home.png": "uYPF",
	"./home_fill.png": "tSq+",
	"./kehugzt.png": "JZDw",
	"./kehugzt_fill.png": "UdNa",
	"./msg.png": "tZzI",
	"./msg_fill.png": "YdvJ",
	"./platform.png": "Dtgb",
	"./platform_fill.png": "X74+",
	"./reserved_instance.png": "z+9t",
	"./reserved_instance_fill.png": "+g3W",
	"./savings_plan.png": "Q9NG",
	"./savings_plan_fill.png": "30s2",
	"./set.png": "Mw98",
	"./set_fill.png": "HOwm",
	"./table.png": "8nUv",
	"./table_fill.png": "xghU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fFCV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu ^\.\/.*\.png$
// module id = fFCV
// module chunks = 10